export default "__VITE_ASSET__BiSZQVj$__"